
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import { MutationTypes, useStore } from "@/store";
import router from "@/router";
import searchBox from "@/components/searchBox.vue";
import { setCookie } from "@/utils/common";
import { UserService } from "@/api/user";
export default defineComponent({
  name: "Header",
  components: {
    searchBox,
  },
  setup() {
    const store = useStore();
    const userInfo = computed(() => store.state.userInfo);
    const isLogin = computed(() => store.state.token);
    const search = computed(() => store.state.seachKey);
    const currRouter = ref(router.currentRoute.value);
    const noTitleKey = "unread";
    const key = "unread";
    const tabListNoTitle = [
      {
        key: "unread",
        tab: "未读",
      },
      {
        key: "read",
        tab: "全部",
      },
    ];
    const searchKey = reactive({
      keyValue: search.value,
    });
    const onTabChange = (key: any, type: string | number) => {
      this[type] = key;
    };
    const showLoginModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, true);
    };
    const onOutLogin = async () => {
      const res = await UserService.loginOut();
      if (res.data.state === 2) {
        // setCookie('userid', '',7)
        setCookie("tokens", "", -1);
        router.go(0);
      }
      // router.go(0)
    };
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    return {
      isLogin,
      noTitleKey,
      key,
      tabListNoTitle,
      onTabChange,
      userInfo,
      showLoginModal,
      ...toRefs(searchKey),
      onOutLogin,
      onSearch,
      currRouter,
    };
  },
});
